import { createEffect } from 'effector';

import { apiFetch } from '@m/utils/http';

import type { SiteEquipment } from '@m/types/api';

export const getLocationEquipmentList = createEffect({
  handler: ({ id }: { id: number }) => apiFetch(`/admin/location/${id}/equipment`),
});

export const createLocationEquipment = createEffect({
  handler: ({ locationId, body }: { body: SiteEquipment; locationId: number }) =>
    apiFetch(`/admin/location/${locationId}/equipment`, {
      method: 'POST',
      body,
    }),
});

export const updateLocationEquipment = createEffect({
  handler: ({
    locationId,
    equipmentId,
    body,
  }: {
    body: SiteEquipment;
    equipmentId: number;
    locationId: number;
  }) =>
    apiFetch(`/admin/location/${locationId}/equipment/${equipmentId}`, {
      method: 'PUT',
      body,
    }),
});
